<template>
  <section class="axis-page content-padd" :class="{ isMobile }">
    <div class="desc-content content-width">
      <div class="desc-title">
        <h2 class="title-underline icons-title">
          Jak wdrażamy system c-КОB
        </h2>
      </div>
      <div class="axis-cont">
        <div class="axis-cont-c filled">
          <div class="item-line"></div>
          <div class="item-title">1 stycznia 2023 r.</div>
          <div class="item-text">
            Uruchomienie systemu c-KOB (korzystanie dobrowolne)
          </div>
        </div>
        <div class="axis-cont-c filled">
          <div class="item-line"></div>
          <div class="item-title">1 stycznia 2024 r.</div>
          <div class="item-text">
            Obowiązek stosowania c-KOB dla nowych obiektów budowlanych
            oddawanych do użytkowania
          </div>
        </div>
        <div class="axis-cont-c">
          <div class="item-line">
            <div class="arrow"></div>
          </div>
          <div class="item-title">1 stycznia 2032 r.</div>
          <div class="item-text">
            Obowiązek stosowania c-KOB dla wszystkich obiektów budowlanych
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LibHomeSectionAxis",
  components: {},
  props: {
    content: {
      type: String,
      default: "www"
    }
  }
};
</script>

<style lang="scss">
.axis-page {
  color: var(--c-primary);
  text-wrap: pretty;

  .desc-content {
    display: flex;
    gap: 40px;
  }

  .desc-title {
    margin-bottom: 50px;
    flex: 1 0;
  }
  .axis-cont {
    flex: 2 0;
  }

  .axis-cont-c {
    position: relative;
    padding-left: 48px;
    padding-bottom: 30px;
  }
  .item-line {
    position: absolute;
    left: 0;
    top: 6px;
    width: 2px;
    height: 100%;
    background: var(--c-primary-blue);
    &::before {
      content: "";
      display: block;
      position: absolute;
      width: 22px;
      height: 22px;
      border: 2px solid var(--c-primary-blue);
      border-radius: 50%;
      left: -10px;
      top: 0px;
      background: #fff;
    }
  }

  .axis-cont-c.filled {
    .item-line::before {
      background: var(--c-primary-blue);
    }
  }

  .arrow {
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 15px 8px 0 8px;
    border-color: var(--c-primary-blue) transparent transparent transparent;
    transform: rotate(0deg);
    position: absolute;
    bottom: -14px;
    left: -7px;
  }
  .item-title {
    color: var(--c-primary-blue);
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 10px;
    line-height: 1.4;
  }

  .item-text {
    max-width: 520px;
    padding-left: 2px;
  }

  ul {
    margin-top: 0.5rem;
  }
  a {
    color: currentColor !important;
  }
  &.isMobile {
    .desc-content {
      display: block;
    }
  }
}
</style>
